
import { Component, Emit, Prop, Vue, } from 'vue-property-decorator';
import FeedbackBox from '~/components/feedback-box/feedback-box.vue';
import Spinner from '~/components/spinner/spinner.vue';
import { Completed, Result, isComplete, isResult, } from '~/utils/models/result';

@Component({
	components: {
		FeedbackBox,
		Spinner,
	},
})
export default class DashboardTile extends Vue {
	@Prop({
		required: true,
		type: String,
	})
	title!: string;

	@Prop({
		required: false,
		validator: (prop: unknown) => isResult(prop),
		default: () => Completed(undefined),
	})
	loadedContent!: Result<unknown>;

	@Emit()
	reloadContent() {
		// Just emit event
	}

	get hasFooterSlot() {
		// eslint-disable-next-line dot-notation
		return !!this.$slots['footer'];
	}

	isComplete = isComplete;
}
